import { Box, Chip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

interface Props {
  onFilterChange: (selectedFilter: string) => void;
  selectedFilter: string;
}

const LandingPageSidebar = ({ onFilterChange, selectedFilter }: Props) => {
  const { t } = useTranslation();

  const filterOptions = [
    {
      key: "showAll",
      label: t("platform.LandingPage_filterShowAll"),
      value: "Show all",
    },
    {
      key: "analytics",
      label: t("platform.LandingPage_filterAnalytics"),
      value: "Analytics",
    },
    {
      key: "businessIntelligence",
      label: t("platform.LandingPage_filterBusinessIntelligence"),
      value: "Business intelligence",
    },
    {
      key: "sales",
      label: t("platform.LandingPage_filterSales"),
      value: "Sales",
    },
    {
      key: "marketing",
      label: t("platform.LandingPage_filterMarketing"),
      value: "Marketing",
    },
    {
      key: "rewardsAndRecognition",
      label: t("platform.LandingPage_filterRewardsAndRecognition"),
      value: "Rewards and recognition",
    },
    {
      key: "userManagement",
      label: t("platform.LandingPage_filterUserManagement"),
      value: "User management",
    },
  ];

  const handleFilterClick = (filter: string) => {
    if (onFilterChange) {
      onFilterChange(filter);
    }
  };

  return (
    <Box
      sx={{
        width: "320px",
        height: "100%",
        backgroundColor: "#FAE4D3",
        padding: "32px 24px",
        display: "flex",
        flexDirection: "column",
        gap: 3,
      }}
    >
      {/* Title */}
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: "24px",
          lineHeight: 1.3,
          color: "#333",
          marginBottom: "16px",
        }}
      >
        {t("platform.LandingPage_selectAnAppTitle")}
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
          {filterOptions.map(item => {
            return (
              <Chip
                label={item.label}
                onClick={() => handleFilterClick(item.value)}
                sx={{
                  backgroundColor:
                    selectedFilter === item.value ? "#e87722" : "#fff",
                  color: "#e87722",
                  border: "2px solid #e87821",
                  borderRadius: "20px",
                  fontWeight: 800,
                  fontSize: "16px",
                  padding: "8px 16px",
                  height: "40px",
                  cursor: "pointer",
                  "&:hover": {
                    backgroundColor:
                      selectedFilter === item.value
                        ? "#e67e00"
                        : "rgba(255, 140, 0, 0.1)",
                  },
                  "& .MuiChip-label": {
                    color: selectedFilter === item.value ? "white" : "#ff8c00",
                  },
                }}
              />
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

export default LandingPageSidebar;
